import { client as reelsClient } from '@inference.engine/reels-api-client/web';
import { ENV } from '@/lib/config/env';
import { configureApiClient } from './configure-client';
import { blobErrorBodyInterceptor } from './interceptors/blob-error-body.interceptor';

type ReelsHttp = typeof reelsClient;

let instance: ReelsHttp | undefined;

function initClient(): ReelsHttp {
  if (!ENV.REELS_API_BASE_URL) {
    throw new Error('REELS_API_BASE_URL environment variable is not set');
  }

  reelsClient.setConfig({
    throwOnError: true,
  });
  // Registered first, so the problem-details toast after it reads a refused download's body too.
  reelsClient.instance.interceptors.response.use(undefined, blobErrorBodyInterceptor);

  return configureApiClient(reelsClient, ENV.REELS_API_BASE_URL);
}

export const reelsHttp = new Proxy({} as ReelsHttp, {
  get(_target, prop) {
    instance ??= initClient();
    return Reflect.get(instance, prop, instance);
  },
});
